import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "px-2 rounded-full bg-blue-500 text-white text-xs font-bold uppercase"
}
const _hoisted_2 = { class: "text-sm" }
const _hoisted_3 = {
  key: 1,
  class: "flex items-center space-x-1 text-xs font-bold uppercase"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Box = _resolveComponent("Box")!

  return (_openBlock(), _createBlock(_component_Box, {
    as: "li",
    role: "option",
    tabindex: "0",
    class: "w-full p-2 border border-current rounded-lg cursor-pointer hover:bg-blue-100"
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        (_ctx.candidate.type)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.candidate.type), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.candidate.name), 1),
        (_ctx.candidate.city || _ctx.candidate.state)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_ctx.candidate.city)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.candidate.city) + ",", 1))
                : _createCommentVNode("", true),
              (_ctx.candidate.state)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.candidate.state), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 3
  }))
}